// hooks/useRNWebViewTranslation.js
import { useEffect, useState } from 'react'

declare global {
  interface Window {
    ReactNativeWebView?: any
  }
}

const useRNWebViewTranslation = () => {
  const [hasRNWebView, setHasRNWebView] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined' && window.ReactNativeWebView) {
      setHasRNWebView(true)
    }
  }, [])

  return hasRNWebView
}

export default useRNWebViewTranslation
